import React, { Component, Fragment } from 'react';
import Header from './Header';
import CSVGenerator from '../utils/json2csv';
import _ from 'lodash';
import moment from 'moment';
import Table from './Table';
import { getPaymentsReport,getAccountingReport, getBillSubmissionReport } from '../utils/PaymentRequestApiUtils';
import { TextField, Button, Snackbar, LinearProgress, Dialog, DialogContent } from '@material-ui/core';
import { getPaymentsReportCSVData, getAccountingReportCSVData, getBillSubmissionReportCSVData } from './Reports';
import { billSubReportStatusMap, businessUnitMap } from '../constants/paymentStatus';

class BillSubmissionReport extends Component{
    constructor(){
        super();
        this.state = {
            data: [],
            fromDate: '',
            toDate: '',
            fromDateShow: '',
            toDateShow: '',
            fromDateErr: false,
            fromDateErrText: '',
            toDateErr: false,
            toDateErrText: '',
            inProgress: false,
            snackMessage: "",
            snackOpen: false,
            validationsDialogOpen: false,
            validationErrors: [],
            dialogBoxText: "",
            showDownloadButton: false,
            paymentsReportColumns: [],
            accountingReportColumns: [],
            billSubmissionReportColumns: [],
        }
        this.handleChange = this.handleChange.bind(this);
        this.submitFilter = this.submitFilter.bind(this);
        this.clearFilter = this.clearFilter.bind(this);
        this.generateCSV = this.generateCSV.bind(this);
        this.handleCloseSnack = this.handleCloseSnack.bind(this);
        this.handleFetchData = this.handleFetchData.bind(this);
    }

    componentWillMount(){
        this.setState({
            showDownloadButton: true, 
            paymentsReportColumns: this.props.location.state.paymentsReportColumns, 
            accountingReportColumns: this.props.location.state.accountingReportColumns,
            billSubmissionReportColumns: this.props.location.state.billSubmissionReportColumns
        })
    }
    componentDidMount(){
        this.handleFetchData()
    }

    handleChange = (props) => (event, index, value) => {
        this.setState({ [props]: event.target.value, [props + 'Err']: false, [props + 'ErrText']: '' })
    }

    async submitFilter() {

        if (this.state.toDateShow !== '' && this.state.toDateShow < this.state.fromDateShow) {
            this.setState({ snackOpen: true, snackMessage: 'From date should be less than To date' })
            return
        }
        
        if (this.state.fromDateShow !== '' && this.state.fromDateShow > this.state.toDateShow) {
            this.setState({ snackOpen: true, snackMessage: 'To date should be greater than From date' })
            return
        }
        this.setState({fromDate: this.state.fromDateShow, toDate: this.state.toDateShow}, () =>
            this.handleFetchData({from_date: this.state.fromDate, to_date: this.state.toDate})
        )
        
    }

    handleFetchData(filters = {}){
        this.setState({ inProgress: true },() => {
            getBillSubmissionReport(filters).then(response => {
                if (response) {
                    if (response.status === 'success') {
                        let data = response.data.map(data => {
                            return { 
                                ...data,
                                transaction_date: (data.transaction_date)?moment(data.transaction_date).format('DD-MM-YYYY'): '-',
                                L1_approver_date: (data.L1_approver_date)?moment(data.L1_approver_date).format('DD-MM-YYYY'): '-',
                                L2_approver_date: (data.L2_approver_date)?moment(data.L2_approver_date).format('DD-MM-YYYY'): '-',
                                L3_approver_date: (data.L3_approver_date)?moment(data.L3_approver_date).format('DD-MM-YYYY'): '-',
                                L4_approver_date: (data.L4_approver_date)?moment(data.L4_approver_date).format('DD-MM-YYYY'): '-',
                                zaps_approver_l1_name: (data.zaps_approver_l1_name)?data.zaps_approver_l1_name: '-',
                                approverId1_at: (data.approverId1_at)?moment(data.approverId1_at).format('DD-MM-YYYY hh:mm A'): '-',
                                zaps_approver_l2_name: (data.zaps_approver_l2_name)?data.zaps_approver_l2_name: '-',
                                approverId2_at: (data.approverId2_at)?moment(data.approverId2_at).format('DD-MM-YYYY hh:mm A '): '-',
                                bill_submissions_date: (data.bill_submissions_date)?moment(data.bill_submissions_date).format('DD-MM-YYYY'): '-',
                                total_payable_amount: (data.total_payable_amount)?data.total_payable_amount: '-',
                                date_of_invoice: (data.date_of_invoice)?moment(data.date_of_invoice).format('DD-MM-YYYY'): '-',
                                status: billSubReportStatusMap[data.status].value,
                                invoice_due_date: (data.invoice_due_date)?moment(data.invoice_due_date).format('DD-MM-YYYY'): '-',
                                created_at: (data.created_at)?moment(data.created_at).format('DD-MM-YYYY hh:mm A'): '-',
                                type_of_transaction: (data.type_of_transaction)?data.type_of_transaction: '-',
                                business_unit: (data.business_unit && businessUnitMap[data.business_unit] && businessUnitMap[data.business_unit].value) ? businessUnitMap[data.business_unit].value : '-',
                                name: (data.name)?data.name: '-',
                                transaction_id: (data.transaction_id)?data.transaction_id: '-',
                                city_finance_remarks: (data.city_finance_remarks) ? data.city_finance_remarks : '-',
                                city_head_remarks: (data.city_head_remarks) ? data.city_head_remarks : '-',
                                central_finance_remarks: (data.central_finance_remarks) ? data.central_finance_remarks : '-',
                                bs_Id: (data.bs_Id)?data.bs_Id: '-',
                                bs_requesterEmail: (data.bs_requesterEmail)?data.bs_requesterEmail: '-',
                                city: (data.CITY)?data.CITY: '-',
                                deleted_at: (data.deleted_at)?moment(data.deleted_at).format('DD-MM-YYYY hh:mm A'): '-',
                                deleted_by: (data.deleted_by)?data.deleted_by: '-',
                                accounting_status: data.accounting_status === 'accounted' ? 'Accounted' : 'Unaccounted',
                                accounting_status_date: data.accounting_status_date ? moment(data.accounting_status_date).format('DD-MM-YYYY hh:mm A') : '-',
                                hold_unhold_date: data.hold_unhold_date ? moment(data.hold_unhold_date).format('DD-MM-YYYY hh:mm A') : '-',
                                accounting_status_by: data.accounting_status_by ? data.accounting_status_by : '-',
                                hold_comment: data.hold_comment ? data.hold_comment : '-',
                                unhold_comment: data.unhold_comment ? data.unhold_comment : '-',
                                hold_unhold_by: data.hold_unhold_by ? data.hold_unhold_by : '-',
                                beneficiary_account_number: data.beneficiary_account_number ? data.beneficiary_account_number : '-',
                                beneficiary_name: data.beneficiary_name ? data.beneficiary_name : '-',
                            }
                        })
                        this.setState({ data, inProgress: false })
                    }
                    else {
                        this.setState({ snackMessage: response.message, snackOpen: true, inProgress: false })
                    }
                }
            })
        })
    }


    handleCloseSnack() {
        this.setState({ snackOpen: false })
    }
    
    clearFilter() {
        this.setState({ fromDate: '', toDate: '', fromDateShow: '', toDateShow: '', fromDateErr: false, fromDateErrText: '', toDateErr: false, toDateErrText: '' })
        this.handleFetchData();
    }

    async generateCSV() {
        let csvData = await getBillSubmissionReportCSVData(this.state.data);
        CSVGenerator(csvData.headers, csvData.data, csvData.filename)
    }

    generateAllCSVs() {
        
        // Download Bill Submission Report
        this.generateCSV();

        // Download Payments Report
        let paymentsReportCSVData = {};
        getPaymentsReport({from_date: this.state.fromDate, to_date: this.state.toDate}).then(response => {
            if (response) {
                if (response.status === 'success') {
                    let paymentsReportData = response.data.map(data => {
                        return { 
                            ...data,
                            transaction_date: (data.transaction_date)?moment(data.transaction_date).format('DD-MM-YYYY'):data.transaction_date,
                        }
                    })
                    this.setState({ paymentsReportData });
                }
                else {
                    this.setState({ snackMessage: response.message, snackOpen: true, inProgress: false })
                }
            }
        }).then(async () => {
            paymentsReportCSVData = await getPaymentsReportCSVData(this.state.paymentsReportData);
        }).then(() => CSVGenerator(paymentsReportCSVData.headers, paymentsReportCSVData.data, paymentsReportCSVData.filename));

        // Download Accounting Report
        let accountingReportCSVData = {};
        getAccountingReport({from_date: this.state.fromDate, to_date: this.state.toDate}).then(response => {
            if (response) {
                if (response.status === 'success') {
                    let accountingReportData = response.data.map(data => {
                        return { 
                            ...data,
                            transaction_date: (data.transaction_date)?moment(data.transaction_date).format('DD-MM-YYYY'):data.transaction_date,
                            payment_request_date: (data.payment_request_date)?moment(data.payment_request_date).format('DD-MM-YYYY'):data.payment_request_date,
                        }
                    })
                    this.setState({ accountingReportData });
                }
                else {
                    this.setState({ snackMessage: response.message, snackOpen: true, inProgress: false })
                }
            }
        }).then(async () => {
            accountingReportCSVData = await getAccountingReportCSVData(this.state.accountingReportData);
        }).then(() => CSVGenerator(accountingReportCSVData.headers, accountingReportCSVData.data, accountingReportCSVData.filename));
    }

    render(){
        return(
            <Fragment>
                <Header />
        <div className="zaps-page-wrap">
          <div className="zaps-page-header">
            <div>
              <h2 className="zaps-page-title">Bill Submission Report</h2>
              <p className="zaps-page-subtitle">Track bill submissions, approvals and invoice status</p>
            </div>
          </div>
                <h4 style={{textAlign: 'center'}}>Details showing from {this.state.fromDate && this.state.toDate?this.state.fromDate:moment().startOf('month').format("YYYY-MM-DD")} to {this.state.toDate && this.state.fromDate?this.state.toDate:moment().endOf('month').format("YYYY-MM-DD")}</h4>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '20px', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <div>
                    Select Transaction Date Range:&nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="date"
                        label="From Date"
                        type="date"
                        InputLabelProps={{
                        shrink: true,
                        }}
                        value={this.state.fromDateShow}
                        onChange={this.handleChange('fromDateShow')}
                        style={{ marginRight: '20px' }}
                        error={this.state.fromDateErr}
                        helperText={this.state.fromDateErrText}
                        margin='normal'
                    />
                    <TextField
                        id="date"
                        label="To Date"
                        type="date"
                        InputLabelProps={{
                        shrink: true,
                        }}
                        value={this.state.toDateShow}
                        onChange={this.handleChange('toDateShow')}
                        style={{ marginRight: '20px' }}
                        error={this.state.toDateErr}
                        helperText={this.state.toDateErrText}
                        margin='normal'
                    />
                    </div>
                    <div>
                    <Button variant="contained" size="large" color="primary" disabled={this.state.fromDateShow === '' || this.state.toDateShow === ''} onClick={this.submitFilter.bind(this)}
                        style={{ marginRight: '20px', marginTop: '25px' }}>
                        Submit Filter
                        </Button>
                    <Button variant="contained" size="large" color="primary" disabled={this.state.fromDateShow === '' && this.state.toDateShow === ''} onClick={this.clearFilter.bind(this)}
                        style={{ background: 'red', marginTop: '25px' }}>
                        Clear Filter
                        </Button>
                    </div>
                </div>
                <div style={{ marginTop: '25px' }} >
                {this.state.showDownloadButton && <Button variant="contained" size="large" color="primary" disabled={this.state.data.length === 0} onClick={this.generateCSV.bind(this)}
                        style={{ marginRight: '20px'}}>
                        Download CSV
                    </Button>}
                {/* {this.state.showDownloadButton && <Button variant="contained" size="large" color="primary" disabled={this.state.data.length === 0} onClick={this.generateAllCSVs.bind(this)}
                        style={{ marginRight: '20px'}}>
                        Download ALL
                    </Button>} */}
                </div>
    </div>
                <Table columns={this.state.billSubmissionReportColumns} data={this.state.data} />
                <Dialog
                open={this.state.inProgress}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        Loading...
                        <br/><br/>
                        <LinearProgress />
                    </DialogContent>
                </Dialog>
                <Snackbar
                open={this.state.snackOpen}
                message={this.state.snackMessage}
                autoHideDuration={2500}
                onClose={this.handleCloseSnack.bind(this)}
                />
          
        </div>{/* end zaps-page-wrap */}
      </Fragment>
        )
    }
}

export default BillSubmissionReport;



// WEBPACK FOOTER //
// ./src/components/BillSubmissionReport.js